export default __webpack_public_path__ + "static/media/dark_bg_mobile.747ebcff.jpg";